import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.75 7.856l-.53-.53-.53.53.53.53.53-.53zm7.308.002v.75-.75zm5.192 5.192h-.75.75zm-5.192 5.192v-.75.75zm-3.922-8.06L6.28 7.325l-1.06 1.06 2.856 2.856 1.06-1.06zM6.28 8.385L9.136 5.53l-1.06-1.06L5.22 7.326l1.06 1.06zm-.53.22l7.307.002v-1.5L5.75 7.106v1.5zM17.5 13.05a4.442 4.442 0 01-4.442 4.442v1.5A5.942 5.942 0 0019 13.05h-1.5zm-4.442-4.442A4.442 4.442 0 0117.5 13.05H19a5.942 5.942 0 00-5.942-5.942v1.5zM6.135 18.992h6.923v-1.5H6.135v1.5z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 6.748l-.53-.53-.53.53.53.53.53-.53zm9.5.002v.75-.75zm6.75 6.75h-.75.75zm-6.75 6.75v-.75.75zM8.243 9.93L4.53 6.218l-1.06 1.06 3.713 3.713 1.06-1.061zM4.53 7.278l3.713-3.713-1.06-1.06L3.47 6.218l1.06 1.06zm-.53.22l9.5.002V6L4 5.998v1.5zM19.5 13.5a6 6 0 01-6 6V21a7.5 7.5 0 007.5-7.5h-1.5zm-6-6a6 6 0 016 6H21A7.5 7.5 0 0013.5 6v1.5zM4.5 21h9v-1.5h-9V21z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M15.465 21.022L8.1 13.637m0 0l7.365-7.387M8.1 13.637l18.845.004c7.395 0 13.39 6.013 13.39 13.43 0 7.416-5.995 13.429-13.39 13.429H9.09"
  }))
};
export var Undo = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});